<template>
  <div class="base-input-number">
    <div class="flex">
      <button class="button-qty p0" @click="minusQtyProduct">
        <span class="material-icons qty-icon">remove</span>
      </button>
      <input
        v-model="customValue"
        :ref="'input'+sku"
        type="number"
        :focus="autofocus"
        :min="min"
        :disabled="onDisable"
        class="m0 no-outline base-input-number__input brdr-cl-primary bg-cl-transparent h4"
        @input="onInput"
        @change="fixQty"
        data-hj-whitelist
      >
      <button class="button-qty p0" @click="plusQtyProduct" >
        <span class="material-icons qty-icon">add</span>
      </button>

    </div>
    <ValidationMessages v-if="validations" :validations="validations" />
  </div>
</template>

<script async>
const ValidationMessages = () => import(/* webpackChunkName: "vsf-validation-messages" */ 'theme/components/core/blocks/Form/ValidationMessages.vue');

export default {
  name: 'BaseInput',
  components: {
    ValidationMessages
  },
  data () {
    return {
      customValue: '',
      inputStatus: false
    }
  },
  mounted () {
    this.customValue = this.value
    this.inputStatus = false
  },
  computed: {
    currentQty () {
      if (this.useQtyInCart) {
        if (isNaN(this.qtyInCart)) {
          return this.qty;
        } else {
          let correctQtyInCart = parseInt(this.qtyInCart);
          let currentQty = this.qty - correctQtyInCart;
          if (currentQty > 0) {
            return currentQty;
          } else {
            return 1;
          }
        }
      } else {
        return this.qty;
      }
    },
    refName () {
      return 'input' + this.sku;
    },
    qtyIncrement () {
      return this.qtyIncrements ? this.qtyIncrements : 1
    }
  },
  watch: {
    sku () {
      this.customValue = this.value
      this.inputStatus = false
    },
    currentQty () {
      let intCustomValue = parseInt(this.customValue);
      if (intCustomValue > this.currentQty) {
        this.customValue = this.currentQty;
      }
      this.$emit('refresh', { newValue: this.customValue });
    }
  },
  methods: {
    onBlur (event) {
      let value = event.target.value
      if (value === 'custom') {
        this.inputStatus = true;
        this.customValue = this.value
        this.$emit('blur', this.value)
        this.$refs[this.refName].focus();
      } else {
        this.customValue = value
        this.$emit('blur', value)
      }
    },
    onInput (event) {
      let value = event.target.value
      if (!value || value < 1) return
      if (value === 'custom') {
        this.inputStatus = true;
        this.customValue = this.value
        this.$emit('input', this.customValue)
      } else {
        this.$emit('changeOptionQty', value, 'input')
        value = value >= this.currentQty ? this.currentQty : value
        this.customValue = value
        this.$emit('input', value)
      }
    },
    minusQtyProduct () {
      if (this.customValue <= this.qtyIncrement) {
        return true
      } else {
        this.$emit('changeOptionQty', this.customValue, 'minus')
        this.customValue -= this.qtyIncrement;
        this.$emit('input', this.customValue);
      }
    },
    plusQtyProduct () {
      if (this.customValue >= this.currentQty) {
        return true
      } else {
        this.$emit('changeOptionQty', this.customValue, 'plus')
        this.customValue += this.qtyIncrement
        this.$emit('input', this.customValue);
      }
    },
    onClick () {
      this.inputStatus = true;
    },
    fixQty () {
      if (isNaN(this.customValue) || this.customValue < 1) {
        this.customValue = 1;
        this.$emit('input', this.customValue);
      } else {
        this.customValue = Math.round(this.customValue);
        this.$emit('input', this.customValue);
      }
      this.$emit('refresh', { newValue: this.customValue });
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: 0
    },
    qty: {
      type: [Number],
      default: 20
    },
    sku: {
      type: [String],
      required: true
    },
    qtyInCart: {
      required: true
    },
    onDisable: {
      type: Boolean,
      default: false
    },
    useQtyInCart: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    min: {
      type: Number,
      default: 0
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false
    },
    validations: {
      type: Array,
      default: () => []
    },
    qtyIncrements: {
      required: true,
      default: 1
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~theme/css/variables/colors';
  @import '~theme/css/helpers/functions/color';


  .button-qty {
    border: none;
    background: none;
    color: #000;
  }
  .base-input-number {
    width: 100%;

    &__input {
      font-family: 'TTNorms Regular', sans-serif;
      text-align: center;
      border-style: solid;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.09px;
      color: #111111;
      border-width: 0 0 0 0;
      width: 40px;
      height: 1.4rem;
      /*line-height: 1.7rem;*/
      -moz-appearance: textfield;
      @media (min-width: 769px) {
        /*height: 1.7rem;*/
      }
      &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }

    &__label {
      font-size: 0.8rem;
      line-height: 1.2rem;
      max-width: 100px;
      @media (min-width: 769px) {
        font-size: 1rem;
        line-height: 1.4rem;
      }
    }
  }

  .select {
    width: 100%;
  }

  .backButton {
    font-size: 16px;
    color: white;
    border: 0px;
    border-radius: 0px;
    background-color: #4F4F4F;
  }
  .qty-icon {
    display: inline-block;
    width: 22px;
    height: 22px;
    overflow: hidden;
    font-size: 20px;
    color: #11bb2e;
    border: 1px solid #11bb2e;
    border-radius: 50%;
  }
</style>
